<ion-radio-group multiple>
    <ion-list-header>
        <ion-label>
            <span class="title">{{ selection.menuSelection.name }}</span>
            <ng-container *ngIf="!!orderItemSelection && orderItemSelection.countTotal() !== 0">
                ({{ orderItemSelection.countTotal() | currency }})
            </ng-container>
            <span class="selection-summary">
                {{ selection.menuSelection.selectionMessage }}
            </span>
        </ion-label>
        <ion-button color="dark" (click)="displaySelectionPricingInfo(selection)">
            <ion-icon name="help-circle-outline" slot="icon-only"></ion-icon>
        </ion-button>
    </ion-list-header>
    <bb-menu-item-selection [menuItemSelection]="selection"
                            [parentOrderItem]="orderItem"
                            [terminalMode]="terminalMode"
                            (adjustInventory)="adjustInventory(null, $event)"
                            (itemSelected)="openItemModal($event, selection)">
    </bb-menu-item-selection>
</ion-radio-group>

<ion-popover [isOpen]="!!selectionPrices" (didDismiss)="selectionPrices = null">
    <ng-template>
        <ion-content>
            <ion-item>
                <ion-label>Additional Price Info</ion-label>
            </ion-item>
            <ion-list>
                <ion-item *ngFor="let price of selectionPrices; let index = index;" lines="none">
                    {{ (!price.price || price.price === 0) ? 'Included ' : (price.price | currency) + ' each' }} for
                    {{
                        index === 0 ? 'first ' + price.countMax : (price.countMax
                            ? ' next ' + (price.countMax - price.countMin + 1)
                            : price.countMin + ' or more')
                    }}
                </ion-item>
            </ion-list>
        </ion-content>
    </ng-template>
</ion-popover>
